import { render, staticRenderFns } from "./UploadZone.vue?vue&type=template&id=09d081b2&scoped=true"
import script from "./UploadZone.vue?vue&type=script&lang=js"
export * from "./UploadZone.vue?vue&type=script&lang=js"
import style0 from "./UploadZone.vue?vue&type=style&index=0&id=09d081b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d081b2",
  null
  
)

export default component.exports